module.exports = __webpack_public_path__ + "img/悬浮购物车.37f6bd47.png";